export default "__VITE_ASSET__BOVFp1do__"